import React from 'react';

export const mainNavRef = React.createRef<HTMLDivElement>();
